import { Coach } from '../../store/coach/types';
import { MeetingsMap } from '../../store/meetings/types';
import { Language } from '../../store/languages/types';

export interface MeetingsProps {
    error: string;
    languages: Language[];
    userId: string;
    meetings: MeetingsMap;
    coach?: Coach | null;
}

export enum MeetingStatus {
    New = 'new',
    Confirmed = 'confirmed',
    Cancelled = 'cancelled',
}

export type MeetingsCategory = {
    id: MeetingStatus;
    name: Record<string, string>;
    image?: string;
};
